import type { SVGProps } from 'react';
const SvgCarRental = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#car_rental_svg__a)">
      <path d="M16.39 9H7.61c-.43 0-.81.28-.95.68l-1.66 5v6.81c0 .29.23.51.5.51h1c.28 0 .5-.22.5-.5V20h10v1.5c0 .28.22.5.5.5h1c.28 0 .5-.22.5-.5v-6.81l-1.66-5a1.01 1.01 0 0 0-.95-.69Zm-8.61 9c-.68 0-1.22-.54-1.22-1.22 0-.68.54-1.22 1.22-1.22.68 0 1.22.55 1.22 1.22C9 17.45 8.46 18 7.78 18Zm8.44 0c-.67 0-1.22-.54-1.22-1.22 0-.68.54-1.22 1.22-1.22.68 0 1.22.54 1.22 1.22 0 .68-.54 1.22-1.22 1.22Zm-9.93-4 1.33-4h8.78l1.33 4H6.29ZM10.83 3A3.01 3.01 0 0 0 8 1C6.34 1 5 2.34 5 4c0 1.65 1.34 3 3 3 1.3 0 2.41-.84 2.83-2H16v2h2V5h1V3h-8.17ZM8 5c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1Z" />
    </g>
    <defs>
      <clipPath id="car_rental_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgCarRental;
